import { InternshipFunctions } from 'api/orgs';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { Action } from '../actions/internshipFunctions';

export type State = InternshipFunctions | null | undefined;
export default function internshipFunctions(
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: State = null,
  action: Action
) {
  switch (action.type) {
    case 'INTERNSHIP_FUNCTIONS_SET': {
      return action.internshipFunctions;
    }

    default:
      // this causes a flow error if there are any unhandled actions
      action as never; // eslint-disable-line no-unused-expressions

      return state;
  }
}
